/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OWGameSteamDataPcRequirements,
    OWGameSteamDataPcRequirementsFromJSON,
    OWGameSteamDataPcRequirementsFromJSONTyped,
    OWGameSteamDataPcRequirementsToJSON,
    OWGameSteamDataPlatforms,
    OWGameSteamDataPlatformsFromJSON,
    OWGameSteamDataPlatformsFromJSONTyped,
    OWGameSteamDataPlatformsToJSON,
    OWGameSteamDataSupportInfo,
    OWGameSteamDataSupportInfoFromJSON,
    OWGameSteamDataSupportInfoFromJSONTyped,
    OWGameSteamDataSupportInfoToJSON,
} from './';

/**
 * Raw Steam API data
 * @export
 * @interface OWGameSteamData
 */
export interface OWGameSteamData {
    [key: string]: object | any;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    shortDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    detailedDescription?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWGameSteamData
     */
    genres?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWGameSteamData
     */
    developers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWGameSteamData
     */
    publishers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    releaseDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    headerImage?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    capsuleImage?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    capsuleImageV5?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    background?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    backgroundRaw?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWGameSteamData
     */
    screenshots?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWGameSteamData
     */
    categories?: Array<string>;
    /**
     * 
     * @type {OWGameSteamDataPlatforms}
     * @memberof OWGameSteamData
     */
    platforms?: OWGameSteamDataPlatforms;
    /**
     * 
     * @type {number}
     * @memberof OWGameSteamData
     */
    recommendations?: number;
    /**
     * 
     * @type {number}
     * @memberof OWGameSteamData
     */
    achievements?: number;
    /**
     * 
     * @type {number}
     * @memberof OWGameSteamData
     */
    dlc?: number;
    /**
     * 
     * @type {number}
     * @memberof OWGameSteamData
     */
    movies?: number;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamData
     */
    website?: string;
    /**
     * 
     * @type {OWGameSteamDataPcRequirements}
     * @memberof OWGameSteamData
     */
    pcRequirements?: OWGameSteamDataPcRequirements;
    /**
     * 
     * @type {OWGameSteamDataSupportInfo}
     * @memberof OWGameSteamData
     */
    supportInfo?: OWGameSteamDataSupportInfo;
}

export function OWGameSteamDataFromJSON(json: any): OWGameSteamData {
    return OWGameSteamDataFromJSONTyped(json, false);
}

export function OWGameSteamDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameSteamData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
            ...json,
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'shortDescription': !exists(json, 'shortDescription') ? undefined : json['shortDescription'],
        'detailedDescription': !exists(json, 'detailedDescription') ? undefined : json['detailedDescription'],
        'genres': !exists(json, 'genres') ? undefined : json['genres'],
        'developers': !exists(json, 'developers') ? undefined : json['developers'],
        'publishers': !exists(json, 'publishers') ? undefined : json['publishers'],
        'releaseDate': !exists(json, 'releaseDate') ? undefined : json['releaseDate'],
        'headerImage': !exists(json, 'headerImage') ? undefined : json['headerImage'],
        'capsuleImage': !exists(json, 'capsuleImage') ? undefined : json['capsuleImage'],
        'capsuleImageV5': !exists(json, 'capsuleImageV5') ? undefined : json['capsuleImageV5'],
        'background': !exists(json, 'background') ? undefined : json['background'],
        'backgroundRaw': !exists(json, 'backgroundRaw') ? undefined : json['backgroundRaw'],
        'screenshots': !exists(json, 'screenshots') ? undefined : json['screenshots'],
        'categories': !exists(json, 'categories') ? undefined : json['categories'],
        'platforms': !exists(json, 'platforms') ? undefined : OWGameSteamDataPlatformsFromJSON(json['platforms']),
        'recommendations': !exists(json, 'recommendations') ? undefined : json['recommendations'],
        'achievements': !exists(json, 'achievements') ? undefined : json['achievements'],
        'dlc': !exists(json, 'dlc') ? undefined : json['dlc'],
        'movies': !exists(json, 'movies') ? undefined : json['movies'],
        'website': !exists(json, 'website') ? undefined : json['website'],
        'pcRequirements': !exists(json, 'pcRequirements') ? undefined : OWGameSteamDataPcRequirementsFromJSON(json['pcRequirements']),
        'supportInfo': !exists(json, 'supportInfo') ? undefined : OWGameSteamDataSupportInfoFromJSON(json['supportInfo']),
    };
}

export function OWGameSteamDataToJSON(value?: OWGameSteamData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
            ...value,
        'name': value.name,
        'description': value.description,
        'shortDescription': value.shortDescription,
        'detailedDescription': value.detailedDescription,
        'genres': value.genres,
        'developers': value.developers,
        'publishers': value.publishers,
        'releaseDate': value.releaseDate,
        'headerImage': value.headerImage,
        'capsuleImage': value.capsuleImage,
        'capsuleImageV5': value.capsuleImageV5,
        'background': value.background,
        'backgroundRaw': value.backgroundRaw,
        'screenshots': value.screenshots,
        'categories': value.categories,
        'platforms': OWGameSteamDataPlatformsToJSON(value.platforms),
        'recommendations': value.recommendations,
        'achievements': value.achievements,
        'dlc': value.dlc,
        'movies': value.movies,
        'website': value.website,
        'pcRequirements': OWGameSteamDataPcRequirementsToJSON(value.pcRequirements),
        'supportInfo': OWGameSteamDataSupportInfoToJSON(value.supportInfo),
    };
}


